import { FIND_ASSIGNABLE_ROUTINES, SortDirectionEnum } from '@gripp/shared-logic';
import { InfiniteDataGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoutineColumns } from './useRoutineColumns';

export type EditGroupRoutinesListProps = {
  workspace: any;
  groupId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const EditGroupRoutinesList = ({
  workspace,
  groupId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: EditGroupRoutinesListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => {
    if (assignments && workspace?.id) {
      return {
        keyword,
        groupId,
        assignments,
        workspaceId: workspace?.id,
      };
    }
    return undefined;
  });
  const columns = useRoutineColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({
      keyword,
      groupId,
      assignments,
      workspaceId: workspace?.id,
    });
  }, [keyword, groupId, workspace]);

  if (!filter) return null;

  return (
    <InfiniteDataGrid
      modelName="routine"
      hideResultsLabel={true}
      query={FIND_ASSIGNABLE_ROUTINES}
      filter={filter}
      pageSize={100}
      columns={columns}
      listMaxHeight={maxHeight as number}
      containerStyle={{ height: maxHeight }}
      paddingBottom={0}
      textEmpty={t('routines.textEmpty')}
      dataPrefix="group.findAssignableRoutines"
      orderBy={{ field: 'name', order: SortDirectionEnum.Asc }}
      updateRowsSelected={(rows) => {
        const stringRows = rows.map(row => typeof row === 'string' ? row : row.toString());
        updateAssignments(stringRows);
      }}
      isRowSelected={(row) => {
        const rowIdString = typeof row.id === 'string' ? row.id : row.id.toString();
        const assignmentStrings = assignments.map(id => typeof id === 'string' ? id : id.toString());
        return assignmentStrings.includes(rowIdString);
      }}
      enableScrollRefresh={true}
      showScrollIndicator={true}
    />
  );
};
